export default "__VITE_ASSET__0f8cc5cc__"